import { AspenOrganizationMetadataService, OrganizationMetadataCreateDTO, OrganizationMetadataDTO } from '../client'
import { usePaginatedData } from './usePaginatedData'

import { PaginatedDTO_OrganizationMetadataDTO_ } from '../client/models/PaginatedDTO_OrganizationMetadataDTO_'

export const useOrganizationMetadatas = (initialPage = 1, initialLimit = 10, initialSort = '', initialFilters = {}) => {
    return usePaginatedData<PaginatedDTO_OrganizationMetadataDTO_, OrganizationMetadataCreateDTO, OrganizationMetadataDTO>(
        AspenOrganizationMetadataService.indexOrganizationMetadataGet,
        initialPage,
        initialLimit,
        initialSort,
        initialFilters,
        AspenOrganizationMetadataService.createOrganizationMetadataPost
    )
}
